<template>
  <div class="relative grid gap-2">
    <!-- <div class="absolute left-0 -bottom-3 text-2xs opacity-60">
      ({{ restaurant?.meals?.length === 1 ? '1 meal' : `${restaurant?.meals?.length} meals` }}, {{ timeslotsCount }} timeslots)
    </div> -->
    <div class="absolute left-0 top-0 h-full flex items-center" :class="{ 'w-2/3': preferredTimeslots.length <= 2, 'w-full': preferredTimeslots.length > 2 }"  v-if="pending">
      <AtomSpinner class="w-6 mx-auto white" />
    </div>
    <div :class="{ 'pointer-events-none': pending }">
      <div class="flex gap-2">
        <div v-for="ts in preferredTimeslots" :key="'preferred-timeslot'+ts.timestamp" :class="{ 'w-2/3': preferredTimeslots.length === 1, 'w-1/3': preferredTimeslots.length > 1 }">
          <button class="button-coral text-sm !py-[0.5em] !px-0 !w-full" :class="{ 'opacity-40': ts.waitlist, '!text-transparent': pending }">
            {{ ts.time }} {{ timeslotsCount.length === 1 ? ' - ' + $t('shared.lastTable') : '' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const fat = useFatStore()
const emit = defineEmits(['update:showMeals'])

const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
  showMeals: {
    type: Boolean,
    default: () => false
  },
  pending: {
    type: Boolean,
    default: () => false
  },
  countLabel: {
    type: Boolean,
    default: () => false
  }
})

// Get preferred timeslots
const preferredTimeslots = computed(() => useFatPreferredTimeslots(props.restaurant?.meals, fat.preferredTime, 3))

// Count all available timeslots
const timeslotsCount = computed(() => props?.restaurant?.meals
  ?.map(meal => meal.timeslotsCount)
  ?.reduce((acc, val) => acc + val, 0))
</script>